













































































































import { mapActions } from 'vuex';
import { QuoteState } from '@/models/quote';
import { ErrorManager } from '@/models/error';
import {
  ConfigurationItem,
  IConfigurationItem,
  IConfigurationItemData
} from '@/models/configurator/configuration';

import QuoteStateMixin from '@/mixins/quoteState';
import mixins from '@/utils/mixins';
import auth from '@/mixins/auth';

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue';
import ErrorAlert from '@/components/common/ErrorAlert.vue';
import QuoteLayoutMixin from '@/mixins/quotes/QuoteLayoutMixin';

export default mixins(QuoteStateMixin, QuoteLayoutMixin, auth).extend({
  name: 'QuoteReviewingSurchargesStateCard',

  components: { ErrorAlert, ConfirmationDialog },

  computed: {
    getColor(): string {
      return 'teal darken-2';
    },

    getIcon(): string {
      return 'mdi-cash-fast';
    },

    getString(): string {
      return 'Reviewing Surcharges';
    },

    getActionText(): string {
      return 'Approve';
    }
  },

  data: () => ({
    invalidSurchargeItems: [] as IConfigurationItem[],
    loading: false,

    surchargeApproveConfirmationDialog: false
  }),

  methods: {
    ...mapActions({
      fetchQuoteConfigurationItems: 'quote/fetchQuoteConfigurationItems',
      calculateCoreDiscountPercent: 'quote/calculateCoreDiscountPercent',
      setQuoteState: 'quote/setQuoteState'
    }),

    approve() {
      return this.setState(QuoteState.APPROVED);
    },

    undoDiscountSurcharges() {
      return this.setState(
        this.useMachineLayout(this.quote)
          ? QuoteState.REVIEWING_DISCOUNTS
          : QuoteState.IN_REVIEW
      );
    },

    setState(state: QuoteState) {
      this.clearAllErrors();

      this.loading = true;

      this.setQuoteState({ id: this.quote.number, state })
        .then(({ state }) => {
          this.$emit('state-changed:quote', {
            number: this.quote.number,
            revision: this.quote.revision,
            state: state
          });
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    async fetchQuoteCategoryItems(
      quoteProductCategoryId: number
    ): Promise<IConfigurationItem[]> {
      return this.fetchQuoteConfigurationItems({
        id: this.quote.number!,
        revision: this.quote.revision,
        quoteProductCategory: quoteProductCategoryId,
        language: this.quote.language
      }).then((items: IConfigurationItemData[]) => {
        return items.map(item => new ConfigurationItem(item));
      });
    },

    async checkApprovalStatus() {
      this.invalidSurchargeItems = [];

      this.loading = true;

      let canApprove = false;

      try {
        for (const category of this.quote.categories) {
          const items = await this.fetchQuoteCategoryItems(category.id!);
          for (const item of items) {
            if (!item.country_of_origin || !item.hs_code) {
              this.invalidSurchargeItems.push(item);
            }
          }
        }

        if (this.invalidSurchargeItems.length > 0) {
          this.loading = false;
          canApprove = false;
        } else {
          canApprove = true;
        }
      } catch (error) {
        this.loading = false;
        canApprove = false;
      }

      return canApprove;
    }
  }
});
